import { Modal, Table, TableColumnsType } from "antd";
import React, { useContext, useState } from "react";
import { useTheme } from "../../../Context/ThemeContext";
import { Utils } from "../../../../Utilities/Utils";
import { GSTTableType } from "./GSTReports";

const GSTR1SubModal = ({
  subModalLoading,
  setSubModalLoading,
  tableType,
  tableData1,
  tableData2,
  filterType,
}: any) => {
  const { themeData } = useTheme();
  const sharedOnCell = (rec: any, index?: number) => {
    if (rec.rowType === 1) {
      return { colSpan: 0 };
    }
    return {};
  };
  const table4Columns: TableColumnsType<any> = [
    {
      title: "GSTIN of Suppliers",
      dataIndex: "rowType",
      key: "key",
      onCell: (record, index) => ({
        colSpan: record?.rowType === 1 ? 14 : 1,
      }),
      render: (_, record: any) =>
        record?.rowType === 1 ? (
          <p style={{ fontWeight: "bold" }}>{record?.partyGSTNo}</p>
        ) : (
          <>{record?.partyGSTNo}</>
        ),
    },
    {
      title: "Trade / Legal Name",
      dataIndex: "partyName",
      key: "partyName",
      onCell: sharedOnCell,
    },
    {
      title: "Invoice Details",
      children: [
        {
          title: "Number",
          dataIndex: "number",
          key: "number",
          align: "center",
          onCell: sharedOnCell,
        },
        {
          title: "Type",
          dataIndex: "voucherType",
          key: "voucherType",
          onCell: sharedOnCell,
          // render: (_, record: any) => <>{record?.voucherType}</>,
        },
        {
          title: "Date",
          dataIndex: "date",
          key: "date",
          align: "center",
          onCell: sharedOnCell,
        },
        {
          title: "Value",
          dataIndex: "invoiceValue",
          key: "invoiceValue",
          align: "right",
          onCell: sharedOnCell,
          render: (val: any) => Utils.getFormattedNumber(val),
        },
      ],
    },
    {
      title: "Place of Suppliers",
      dataIndex: "supplyState",
      key: "supplyState",
      onCell: sharedOnCell,
      // render: (_: any, record: any) => <>{record?.supplyState}</>,
    },
    // {
    //   title: "Supply Attract Reverse Charge",
    //   dataIndex: "supply",
    //   key: "supply",
    //   onCell: sharedOnCell,
    //   render: (_: any, record: any) =>
    //     record.rowType !== 1 && (
    //       <>
    //         <p>No</p>
    //       </>
    //     ),
    // },
    {
      title: "Rate(%)",
      dataIndex: "rate",
      key: "rate",
      align: "center",
      onCell: sharedOnCell,
    },
    {
      title: "HSN/SAC",
      dataIndex: "hsnsac",
      key: "hsnsac",
      align: "center",
      onCell: sharedOnCell,
    },
    {
      title: "Taxable Value",
      dataIndex: "taxableAmount",
      key: "taxableAmount",
      align: "right",
      onCell: sharedOnCell,
      render: (val: any) => Utils.getFormattedNumber(val),
    },
    {
      title: "Tax Amount",

      children: [
        {
          title: "Integrated",
          dataIndex: "igstAmt",
          key: "igstAmt",
          align: "right",
          onCell: sharedOnCell,
          render: (val: any) => Utils.getFormattedNumber(val),
        },
        {
          title: "Central",
          dataIndex: "cgstAmt",
          key: "cgstAmt",
          align: "right",
          onCell: sharedOnCell,
          render: (val: any) => Utils.getFormattedNumber(val),
        },
        {
          title: "State/UT",
          dataIndex: "sgstAmt",
          key: "sgstAmt",
          align: "right",
          onCell: sharedOnCell,
          render: (val: any) => Utils.getFormattedNumber(val),
        },
        {
          title: "Cess",
          dataIndex: "cessAmt",
          key: "cessAmt",
          align: "right",
          onCell: sharedOnCell,
          render: (val: any) => Utils.getFormattedNumber(val),
        },
      ],
    },
  ];

  const table5Columns: TableColumnsType<any> = [
    {
      title: "Place of Supply (State/UT)",
      dataIndex: "rowType",
      key: "key",
      onCell: (record, index) => ({
        colSpan: record?.rowType === 1 ? 9 : 1,
      }),
      render: (_, record: any) =>
        record?.rowType === 1 ? (
          <p style={{ fontWeight: "bold" }}>{record?.supplyState}</p>
        ) : (
          <>{record?.supplyState}</>
        ),
    },
    {
      title: "Invoice Details",
      children: [
        {
          title: "Number",
          dataIndex: "number",
          key: "number",
          align: "center",
          onCell: sharedOnCell,
        },
        {
          title: "Type",
          dataIndex: "voucherType",
          key: "voucherType",
          onCell: sharedOnCell,
          // render: (_, record: any) => <>{record?.voucherType}</>,
        },
        {
          title: "Date",
          dataIndex: "date",
          key: "date",
          align: "center",
          onCell: sharedOnCell,
        },
        {
          title: "Value",
          dataIndex: "invoiceValue",
          key: "invoiceValue",
          align: "right",
          onCell: sharedOnCell,
          render: (val: any) => Utils.getFormattedNumber(val),
        },
      ],
    },
    {
      title: "Rate(%)",
      dataIndex: "rate",
      key: "rate",
      align: "center",
      onCell: sharedOnCell,
    },
    {
      title: "Taxable Value",
      dataIndex: "taxableAmount",
      key: "taxableAmount",
      align: "right",
      onCell: sharedOnCell,
      render: (val: any) => Utils.getFormattedNumber(val),
    },
    {
      title: "Tax Amount",

      children: [
        {
          title: "Integrated",
          dataIndex: "igstAmt",
          key: "igstAmt",
          align: "right",
          onCell: sharedOnCell,
          render: (val: any) => Utils.getFormattedNumber(val),
        },
        {
          title: "Cess",
          dataIndex: "cessAmt",
          key: "cessAmt",
          align: "right",
          onCell: sharedOnCell,
          render: (val: any) => Utils.getFormattedNumber(val),
        },
      ],
    },
  ];

  const table8Columns: TableColumnsType<any> = [
    {
      title: "Description",
      dataIndex: "description",
    },
    {
      title: "Nil Rated Supplies",
      dataIndex: "nilRatedSupplies",
      width: "20%",
      align: "right",
      render: (val: any, record: any) => Utils.getFormattedNumber(val),
    },
    {
      title: "Exempted (Other than Nil rated / non-GST supplies)",
      dataIndex: "exemptedSupplies",
      width: "20%",
      align: "right",
      render: (val: any, record: any) => Utils.getFormattedNumber(val),
    },
    {
      title: "Non-GST Supplies",
      dataIndex: "nonGSTSupplies",
      width: "20%",
      align: "right",
      render: (val: any, record: any) => Utils.getFormattedNumber(val),
    },
  ];
  const handleOk = () => {
    setSubModalLoading(false);
  };
  const handleCancel = () => {
    setSubModalLoading(false);
  };
  return (
    <Modal
      open={subModalLoading}
      onOk={handleOk}
      onCancel={handleCancel}
      width={"80%"}
    >
      <div>
        {/* GSTR-1 Tables */}
        {/* Table 4A */}
        {tableType === GSTTableType.GSTR1_4A && tableData1?.length > 0 && (
          <>
            <div style={{ width: "100%", margin: "0 auto" }}>
              <h4
                style={{
                  padding: "5px",
                  borderRadius: 5,
                  color: `${themeData?.themeColor}`,
                  marginTop: "10px",
                  marginBottom: "2px",
                  backgroundColor: `${themeData?.themeColor}10`,
                }}
              >
                Table 4 - Taxable outward supplies made to registered persons
                (including UIN-holders) or, in other words, B2B supplies
              </h4>
              <Table
                bordered
                dataSource={tableData1}
                pagination={false}
                size="small"
                style={{ marginBottom: "30px" }}
                columns={table4Columns}
                // className="ca-viewmodel-table"
                className={`ca-viewmodel-table Tabel-style table-${
                  themeData?.componentSize ?? "middle"
                }`}
                // scroll={
                //   tableData1?.length > 15 ? { x: 700, y: 620 } : { x: 600 }
                // }
              />
            </div>
          </>
        )}

        {/* Table 4B */}
        {tableType === GSTTableType.GSTR1_4B && tableData1?.length > 0 && (
          <>
            <div style={{ width: "100%", margin: "0 auto" }}>
              <h4
                style={{
                  padding: "5px",
                  borderRadius: 5,
                  color: `${themeData?.themeColor}`,
                  marginTop: "10px",
                  marginBottom: "2px",
                  backgroundColor: `${themeData?.themeColor}10`,
                }}
              >
                Table 4 - Taxable outward supplies made to registered persons
                (including UIN-holders) or, in other words, B2B supplies
              </h4>
              <Table
                bordered
                dataSource={tableData1}
                pagination={false}
                size="small"
                style={{ marginBottom: "30px" }}
                columns={table4Columns}
                // className="ca-viewmodel-table"
                className={`ca-viewmodel-table Tabel-style table-${
                  themeData?.componentSize ?? "middle"
                }`}
                // scroll={
                //   tableData1?.length > 15 ? { x: 700, y: 620 } : { x: 600 }
                // }
              />
            </div>
          </>
        )}

        {/* Table 5 */}
        {tableType === GSTTableType.GSTR1_5A && tableData1?.length > 0 && (
          <>
            <div style={{ width: "100%", margin: "0 auto" }}>
              <h4
                style={{
                  padding: "5px",
                  borderRadius: 5,
                  color: `${themeData?.themeColor}`,
                  marginTop: "10px",
                  marginBottom: "2px",
                  backgroundColor: `${themeData?.themeColor}10`,
                }}
              >
                Table 5: Taxable outward inter-state supplies to unregistered
                persons, in other words, B2C supplies, where the invoice value
                is more than Rs. 1 lakh
              </h4>
              <Table
                bordered
                dataSource={tableData1}
                pagination={false}
                size="small"
                style={{ marginBottom: "30px" }}
                columns={table5Columns}
                // className="ca-viewmodel-table"
                className={`ca-viewmodel-table Tabel-style table-${
                  themeData?.componentSize ?? "middle"
                }`}
                // scroll={
                //   tableData1?.length > 15 ? { x: 700, y: 620 } : { x: 600 }
                // }
              />
            </div>
          </>
        )}
        {/* Table 7 */}
        {tableType === GSTTableType.GSTR1_7A &&
          (tableData1?.length > 0 || tableData2?.length > 0) && (
            <>
              <div style={{ width: "100%", margin: "0 auto" }}>
                <h4
                  style={{
                    padding: "5px",
                    borderRadius: 5,
                    color: `${themeData?.themeColor}`,
                    marginTop: "10px",
                    marginBottom: "20px",
                    backgroundColor: `${themeData?.themeColor}10`,
                  }}
                >
                  Table 7 : A rate wise summary of all B2C sales made during the
                  month/quarter where invoice value is less than Rs.1 lakh
                </h4>
                <table
                  className="ca-viewmodel-table"
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    margin: "3px auto",
                  }}
                >
                  <thead>
                    <tr>
                      <th rowSpan={2}>Rate of Tax</th>
                      <th rowSpan={2}>Total Taxable Value</th>
                      <th colSpan={4}>Amount</th>
                    </tr>
                    <tr>
                      <th>Integrated</th>
                      <th>Central</th>
                      <th>State/UT</th>
                      <th>Cess</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td
                        style={{ padding: "2px 4px", fontWeight: "bold" }}
                        colSpan={6}
                      >
                        7A. Intra-State supplies - Consolidated rate wise
                        outward supplies [including supplies made through
                        e-commerce operator attracting TCS]{" "}
                      </td>
                    </tr>
                    {tableData1?.length > 0 ? (
                      tableData1?.map((r: any, rIndex: number) => (
                        <tr>
                          <td
                            align="center"
                            style={{ padding: "2px 4px" }}
                          >{`${r?.taxRate}%`}</td>
                          <td align="right" style={{ padding: "2px 4px" }}>
                            {Utils.getFormattedNumber(r?.taxableValue)}
                          </td>
                          <td align="right" style={{ padding: "2px 4px" }}>
                            {Utils.getFormattedNumber(r?.igstAmt)}
                          </td>
                          <td align="right" style={{ padding: "2px 4px" }}>
                            {Utils.getFormattedNumber(r?.cgstAmt)}
                          </td>
                          <td align="right" style={{ padding: "2px 4px" }}>
                            {Utils.getFormattedNumber(r?.sgstAmt)}
                          </td>
                          <td align="right" style={{ padding: "2px 4px" }}>
                            {Utils.getFormattedNumber(r?.cessAmt)}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td align="center" style={{ padding: "2px 4px" }}></td>
                        <td align="right" style={{ padding: "2px 4px" }}>
                          0.00
                        </td>
                        <td align="right" style={{ padding: "2px 4px" }}>
                          0.00
                        </td>
                        <td align="right" style={{ padding: "2px 4px" }}>
                          0.00
                        </td>
                        <td align="right" style={{ padding: "2px 4px" }}>
                          0.00
                        </td>
                        <td align="right" style={{ padding: "2px 4px" }}>
                          0.00
                        </td>
                      </tr>
                    )}
                    <tr>
                      <td
                        style={{ padding: "2px 4px", fontWeight: "bold" }}
                        colSpan={6}
                      >
                        7B. Inter-State Supplies where invoice value is upto Rs.
                        2.5 lakh - Consolidated rate wise outward supplies
                        [including supplies made through e-commerce operator
                        attracting TCS]
                      </td>
                    </tr>
                    {tableData2?.length > 0 ? (
                      tableData2?.map((r: any, rIndex: number) => (
                        <tr>
                          {r?.rowType === 1 ? (
                            <td colSpan={6} style={{ padding: "2px 4px" }}>
                              <u>{`${r?.supplyState}`}</u>
                            </td>
                          ) : (
                            <>
                              <td
                                align="center"
                                style={{ padding: "2px 4px" }}
                              >{`${r?.taxRate}%`}</td>
                              <td align="right" style={{ padding: "2px 4px" }}>
                                {Utils.getFormattedNumber(r?.taxableValue)}
                              </td>
                              <td align="right" style={{ padding: "2px 4px" }}>
                                {Utils.getFormattedNumber(r?.igstAmt)}
                              </td>
                              <td align="right" style={{ padding: "2px 4px" }}>
                                {Utils.getFormattedNumber(r?.cgstAmt)}
                              </td>
                              <td align="right" style={{ padding: "2px 4px" }}>
                                {Utils.getFormattedNumber(r?.sgstAmt)}
                              </td>
                              <td align="right" style={{ padding: "2px 4px" }}>
                                {Utils.getFormattedNumber(r?.cessAmt)}
                              </td>
                            </>
                          )}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td align="center" style={{ padding: "2px 4px" }}></td>
                        <td align="right" style={{ padding: "2px 4px" }}>
                          0.00
                        </td>
                        <td align="right" style={{ padding: "2px 4px" }}>
                          0.00
                        </td>
                        <td align="right" style={{ padding: "2px 4px" }}>
                          0.00
                        </td>
                        <td align="right" style={{ padding: "2px 4px" }}>
                          0.00
                        </td>
                        <td align="right" style={{ padding: "2px 4px" }}>
                          0.00
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </>
          )}
        {/* Table 8 */}
        {tableType === GSTTableType.GSTR1_8 && tableData1?.length > 0 && (
          <>
            <div style={{ width: "100%", marginTop: "30px" }}>
              <h4
                style={{
                  padding: "5px",
                  borderRadius: 5,
                  color: `${themeData?.themeColor}`,
                  marginTop: "10px",
                  marginBottom: "2px",
                  backgroundColor: `${themeData?.themeColor}10`,
                }}
              >
                Table 8: Nil-rated, exempt and non-GST outward supplies
              </h4>
              <Table
                bordered
                dataSource={tableData1}
                pagination={false}
                size="small"
                style={{ marginBottom: "30px" }}
                columns={table8Columns}
                // className="ca-viewmodel-table"
                className={`ca-viewmodel-table Tabel-style table-${
                  themeData?.componentSize ?? "middle"
                }`}
                // scroll={
                //   gstTable8ReportsData?.length > 15 ? { x: 700, y: 620 } : { x: 600 }
                // }
              />
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};

export default GSTR1SubModal;
